
import React, { Component } from 'react';
import classNames from 'classnames';
import { products } from '../../services';

class FreezeItem extends Component {
  constructor() {
    super();
    this.handleHover = this.handleHover.bind(this);
    this.deleteFreeze = this.deleteFreeze.bind(this);
    this.state = { isHovered: false };
  }

  handleHover(){
    this.setState({
        isHovered: !this.state.isHovered
    });
  }
  deleteFreeze(productId, freezeId){
    products.deleteFutureFreeze(productId, freezeId)
    .then((res) => {
      }).catch(error => {
    console.log(error);
    });
  }
  render() {
    let billsClass = classNames({
      'row': true,
      'row-body': true,
      'nav-item': true,
      'colors': this.state.isHovered
    });
    const {Data, Delete} = this.props
    return (
      <div className={billsClass} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover} style={{ height: 65}} key={Data.id}>
        <div className="col-6 col-md-3 col-lg-2"><small className="hidden-md-up">date: </small><span className="ng-binding">{Data.start}</span></div>
        <div className="col-6 col-md-3 "><small className="hidden-md-up">montant: </small><span className="ng-binding">{Data.end}</span></div>
        <div className="col-4 col-md-2 col-lg-3 text-right">
          <button type="button" className="btn btn-danger" onClick={() => Delete(Data.user_product_id, Data.id)}>Delete</button>
        </div>
      </div>
    )
  }
}
export default FreezeItem;



// WEBPACK FOOTER //
// ./src/components/Freeze/FreezeItem.js